export default __webpack_public_path__ + "static/media/messer-worker.6e107abd.png";